import React, { Component } from "react";

function App(props){
	const { i18n, closeNotice, userInfo } = props;

	return(
		<div className="video-main">
			{
				i18n.lang === "zh_cn"?
				<React.Fragment>
					<p className="video-main-before">录制须知</p>
          {userInfo.recordingTips ? <div className="video-main-text" dangerouslySetInnerHTML={{__html: userInfo.recordingTips.replace(/(\r\n)|(\n)|(\r)/g, "$&<br/>")}} />
          : <div className="video-main-text">
              <p>1.试录只有1道题目，思考时间不超过30秒，答题时间不超过30秒；用以熟悉流程。</p>
              <p>2.正式录制时，请按流程答题，注意倒计时，把握好时间。</p>
              <p>3.每题录制时间不得少于10秒。</p>
              <p>4.可回放，以查看自己在当前题目的表现。可重录，之前录制的视频将删除，本题重新录制。</p>
              <p>5.进入正式录制后，将只可在小程序或PC端单个端口录制；如中途退出，可在面试时间内重新扫码/点击链接进入，最多可再进入3次，进入后将继续上次的视频录制。</p>
              <p>6.录制的视频只用于应聘，不作他用。</p>
            </div>}
				</React.Fragment>:
				<React.Fragment>
					<p className="video-main-before">Audition Recording Info</p>
          {userInfo.recordingTips ? <div className="video-main-text" dangerouslySetInnerHTML={{__html: userInfo.recordingTips.replace(/(\r\n)|(\n)|(\r)/g, "$&<br/>")}} />
            : <div className="video-main-text">
              <p>1. The audition recording only has one question. As well as the thinking time, the answering time is no more than 30 seconds so as to familiarize yourself with the process.</p>
              <p>2. There are many questions in the formal interview, please answer according to the process, pay attention to the countdown, and grasp the time.</p>
              <p>3. The recording time of each question shall not be less than 10 seconds.</p>
              <p>4. It can be played back to see their performance in the current topic. It can be recorded again. The video that was recorded before will be deleted if this topic will be recorded again.</p>
              <p>5. After entering the formal recording, it can only be recorded by the mini program or a single port on PC; If you quit during the interview, you can scan the code again or click the link to enter, and There are 3 times at most for re-enter. The last video recording will continue after re-entering.</p>
              <p>6. Video recorded will only be used for recruitment, not for other purposes.</p>
            </div>}
				</React.Fragment>
			}
			<button className="video-main-back" onClick={closeNotice}>{i18n.noticeModal.okText}</button>
		</div>
	)
}

export default App;
